module.exports = __webpack_public_path__ + "img/clock.1a0509a1.png";